<!--
 * @Author: zyy
 * @Date: 2022-11-16 17:46:10
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-07-18 16:02:18
 * @Description: default
-->
<template>
    <div class="repair-items app-region blank-t-v blank-l-h blank-r-h">
        <a-card :bordered="false">
            <div class="table-page-search-wrapper">
                <H2 style="margin-bottom: 10px">运费模板</H2>
            </div>
            <div class="table-operator" style="margin: 20px 0">
                <a-button type="primary" icon="plus" @click="add()">新增运费模板</a-button>
            </div>
            <a-spin tip="加载中..." :spinning="parentTable.loading">
                <!-- 表格 -->
                <a-table :columns="parentColumns" :data-source="parentTable.data" rowKey="id" :pagination="ipagination"
                    :showHeader="false" @change="handlePageChange">
                    <template slot="child" slot-scope="text, record">
                        <div style="margin-bottom: 50px;">
                            <div class="parentTable-title">
                                <a-row :gutter="[0, 30]">
                                    <a-col :span="19"><span>{{ record.name }}</span></a-col>
                                    <a-col :span="3" class="text-center"><span>最后编辑时间：{{ record.updatetime }}</span></a-col>
                                    <a-col :span="1" class="text-center" @click="add(record)"><a>编辑</a></a-col>
                                    <a-col :span="1" class="text-center" @click="handleDelete(record)"><a>删除</a></a-col>
                                </a-row>
                            </div>
                            <a-table :columns="columns" :data-source="record.express" rowKey="id"
                                :pagination="false"></a-table>
                        </div>
                    </template>
                </a-table>
            </a-spin>
        </a-card>
        <DispatchModelInfo @submit="getList" ref="modelInfoRef" />
    </div>
</template>
  
<script>
import LogisticsModelService from "@/io/logistics/model.js";
import { TJListMixin } from '@/mixins/list.js'
import DispatchModelInfo from './modules/DispatchModelInfo.vue'

export default {
    name: "dispatchModelList",
    components: {
        DispatchModelInfo
    },
    mixins: [TJListMixin],
    data() {
        return {
            modal: {
                show: false,
                loading: false,
                // 0新增，1编辑
                type: 0,
                integralData: null
            },
            rules: {},
            parentColumns: [
                {
                    scopedSlots: { customRender: "child" },
                },
            ],
            columns: [
                {
                    title: "配送区域",
                    key: "area_text",
                    dataIndex: "area_text",
                    ellipsis: true,
                    width: '83%'
                },
                {
                    title: "首件",
                    dataIndex: "first_num",
                },
                {
                    title: "运费(元)",
                    dataIndex: "first_price",
                },
                {
                    title: "续件",
                    dataIndex: "additional_num",
                },
                {
                    title: "续费(元)",
                    dataIndex: "additional_price",
                },
            ],
            parentTable: {
                loading: false,
                data: [],
            },
            table: {
                loading: false,
                data: [],
            },
        };
    },
    methods: {
        async getList() {
            this.parentTable.loading = true;
            const { current, pageSize } = this.ipagination;
            const res = await LogisticsModelService.list({
                page: current,
                limit: pageSize,
            }).then(res => {
                this.parentTable.data = res.data.rows;
                this.ipagination.total = res.data.total;
                this.parentTable.loading = false;
            })

        },

        // 新建
        add(record) {
            this.$refs.modelInfoRef.open(record)

        },
        submit() {
            this.modal.show = false
            this.getList()
        },
        // 删除分类
        async handleDelete({ id }) {
            this.$confirm({
                title: '提示',
                content: '确定要删除该运费模板吗？',
                onOk: () => {
                    LogisticsModelService.del(id).then(res => {
                        if (res.code === 1) {
                            this.$message.success(res.msg)
                            this.getList()
                        } else {
                            this.$message.error(res.msg)
                        }
                    })
                }
            })

        },


    },
};
</script>
<style scoped lang="less">
.text-center {
    text-align: center;
}

.parentTable-title {
    background-color: #e8e8e8;
    padding: 0 20px;
}
</style>
  